import { Check, HousePrivatif } from "../UI/Icons";
import Card from "../UI/Card";
import { Link, useNavigate } from "react-router-dom";
import LocataireShow from "./LocataireShow";
import useTenants from "../../hooks/use-tenants";
import { TenantStatus } from "../../models/tenant_old.js";
import ButtonCard from "../UI/ButtonCard";
import PropertyDisplayImgAddress from "../Property/PropertyDisplayImgAddress";
import { usePublicProperties } from "../../hooks/use-properties";
import IconAndText from "../UI/IconAndText";

export default function LocataireList() {
  const { tenants } = useTenants({ isLocataire: true });
  const { publicPropertiesById } = usePublicProperties({ withById: true });
  const nav = useNavigate();
  const filteredTenants = tenants.filter(
    (tenant) => tenant.status === TenantStatus.Actif.status,
  );
  return (
    <>
      <div className="container">
        <div className="content">
          <Card className={"marginB10"}>
            <p className={"cardTitle text-center"}>
              Qalimo est un logiciel de gestion locative sécurisé gratuit pour
              les locataires.
            </p>
            <p className={"primaryBlue marginT5"}>
              ❌ Qalimo ne s’occupe pas directement de la gestion de votre
              location.
            </p>
            <p className={"primaryBlue marginT5"}>
              ❌ Qalimo n’encaisse aucun loyer. Les paiements sont à faire
              uniquement au propriétaire.{" "}
            </p>
            <p className={"marginT5"}>
              ⚠️ Pour toute demande relative à l’état de votre dossier, un
              document, une quittance de loyer, le dépôt de garantie, etc., il
              faut <strong>contacter directement le propriétaire.</strong>
            </p>
          </Card>
          {filteredTenants.length === 0 && (
            <>
              <Card>
                <p className={"cardTitle"}>Vos premiers pas sur Qalimo</p>
                <p className={"marginT10"}>Avec Qalimo, vous allez pouvoir :</p>
                <IconAndText
                  icon={<Check width="15" height="15" color="green" />}
                  text={
                    <p>
                      Constituer votre dossier de candidature à envoyer au
                      propriétaire
                    </p>
                  }
                  className={"marginT5"}
                />
                <IconAndText
                  icon={<Check width="15" height="15" color="green" />}
                  text={
                    <p>
                      Faire le suivi de votre location et du paiement des loyers
                    </p>
                  }
                  className={"marginT5"}
                />
                <IconAndText
                  icon={<Check width="15" height="15" color="green" />}
                  text={
                    <p>
                      Retrouver tous les documents de votre location une fois le
                      bail signé (contrat de location, état des lieux, quittance
                      de loyer, etc.)
                    </p>
                  }
                  className={"marginT5"}
                />
                <IconAndText
                  icon={<Check width="15" height="15" color="green" />}
                  text={
                    <p>
                      Transmettre de nouveaux documents au propriétaire
                      (attestation d’assurance par exemple)
                    </p>
                  }
                  className={"marginT5"}
                />
                <IconAndText
                  icon={<Check width="15" height="15" color="green" />}
                  text={
                    <p>
                      Souscrire une assurance multirisque habitation avec notre
                      partenaire
                    </p>
                  }
                  className={"marginT5"}
                />
                <p className={"primaryText text-center marginT10"}>
                  Pour commencer, veuillez cliquer sur{" "}
                  <Link to={"/candidat"}>Dossier de candidature</Link> pour
                  créer votre dossier de location
                </p>
              </Card>
            </>
          )}
          {filteredTenants.length === 1 && (
            <LocataireShow tenant={filteredTenants[0]} />
          )}
          {filteredTenants.length > 1 && (
            <>
              <div
                className={"flex justify-content-flex-start align-items-center"}
              >
                <HousePrivatif />
                <h2 className={"marginL5"}>Contrats de location en cours</h2>
              </div>
              <div className={"flex wrap gap10"}>
                {filteredTenants.map((tenant) => {
                  const property = publicPropertiesById[tenant.id_bien];
                  if (!property) return null;
                  return (
                    <ButtonCard
                      key={tenant.id}
                      onClick={() => nav(tenant.id.toString())}
                      className={"padding20"}
                    >
                      <p className={"text-left primaryText marginB10"}>
                        {tenant.nom}
                      </p>
                      <div className={"flex space-between"}>
                        <div className={"flex align-items-end"}>
                          <PropertyDisplayImgAddress property={property} />
                        </div>
                      </div>
                    </ButtonCard>
                  );
                })}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}
